import React from 'react';
import Styles from './Common.module.scss';
import TextTooltip from '../../../../../../../common/_custom/Tooltip/Tooltip';
import infoIcon from '../../../../../../../assets/info.svg';
import clsx from 'clsx';
import { CommonComponentProps } from './types';

const CommonComponent = ({ title, tooltipText, summaryContent, chart, headerRight, isPDFReport = false }: CommonComponentProps) => {
    return (
        <div className={Styles.container}>
            <div className={Styles.header}>
                <div className={Styles.headerLeft}>
                    <h2 className={Styles.heading}>{title}</h2>
                    {tooltipText && !isPDFReport && (
                        <TextTooltip content={tooltipText} direction="right">
                            <img src={infoIcon} alt="info" height="16px" />
                        </TextTooltip>
                    )}
                </div>
                {headerRight && <div className={Styles.headerRight}>{headerRight}</div>}
            </div>

            <div className={Styles.content}>
                {summaryContent}
                <div className={Styles.contentBody}>{chart}</div>
            </div>
        </div>
    );
};

export default CommonComponent;
